// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldCamera = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 10',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.2608 3.1778L13.2188 1.30238L13.2015 1.28501C12.7326 0.486221 11.8817 0 10.9788 0C9.83266 0 8.86022 0.746697 8.53029 1.7886H7.47102C7.14108 0.746697 6.16864 0 5.02255 0C4.1022 0 3.25131 0.486221 2.79982 1.28501L2.78246 1.30238L2.76509 1.31974L2.74773 1.33711L1.72319 3.1778C0.872301 3.83767 0.333984 4.87958 0.333984 6.04304C0.333984 8.05738 1.9663 9.6897 3.98064 9.6897C5.71715 9.6897 7.17581 8.45678 7.54048 6.82446H8.46083C8.82549 8.45678 10.2842 9.6897 12.0207 9.6897C14.035 9.6897 15.6673 8.05738 15.6673 6.04304C15.65 4.87958 15.1116 3.85504 14.2608 3.1778ZM9.39854 6.04304C9.39854 4.60174 10.562 3.43828 12.0033 3.43828C13.4446 3.43828 14.6081 4.60174 14.6081 6.04304C14.6081 7.48433 13.4446 8.64779 12.0033 8.64779C10.562 8.64779 9.39854 7.48433 9.39854 6.04304ZM1.37589 6.04304C1.37589 4.60174 2.53935 3.43828 3.98064 3.43828C5.42194 3.43828 6.5854 4.60174 6.5854 6.04304C6.5854 7.48433 5.42194 8.64779 3.98064 8.64779C2.53935 8.64779 1.37589 7.48433 1.37589 6.04304Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.03196 4.39205C4.17088 4.39205 4.29243 4.27049 4.29243 4.13157C4.29243 3.99265 4.17088 3.87109 4.03196 3.87109C2.83377 3.87109 1.86133 4.84354 1.86133 6.04172C1.86133 6.18064 1.98288 6.3022 2.1218 6.3022C2.26072 6.3022 2.38228 6.18064 2.38228 6.04172C2.38228 5.13874 3.12898 4.39205 4.03196 4.39205Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.4233 6.04172C10.4233 5.13874 11.17 4.39205 12.073 4.39205C12.2119 4.39205 12.3334 4.27049 12.3334 4.13157C12.3334 3.99265 12.2119 3.87109 12.073 3.87109C10.8748 3.87109 9.90234 4.84354 9.90234 6.04172C9.90234 6.18064 10.0239 6.3022 10.1628 6.3022C10.3017 6.3022 10.4233 6.18064 10.4233 6.04172Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldCamera };
